export default "__VITE_ASSET__Djai8wv7__"